export const translations = {
  en: {
    "footer-social-media-section-title": "SOCIAL",
    "footer-social-media-section-description": "Follow us on social media",
    "footer-support-section-title": "SUPPORT",
    "footer-utils-section-title": "INFO",
    "footer-retur-section": "Return Policy",
    "footer-pay-section": "Ship and Payment Methods",
    "footer-terms-section": "Terms and Conditions",
    "header-menu-home": "Home",
    "header-menu-shop": "Shop",
    "header-menu-projects": "Projects",
    "header-menu-support": "Support",
    "login-register-message":
      "Do not have an account yet? Register and let's go!",
    "register-login-message": "Do you already have an account?",
    "login-button": "Login",
    "login-title": "Sign In",
    "register-title": "Sign Up",
    "register-button": "Register",
    "logout-button": "Logout",
    "go-register": "Go to Register",
    "go-login": "Go to Login",
    "register-first-name": "First Name",
    "register-last-name": "Last Name",
    "error-404-page-message":
      "Looks like we ran out of filament... Until we restock you can look through our products!",
    "contact-form-save": "Send",
    "contact-form-email": "Email",
    "contact-form-subject": "Subject",
    "contact-form-msg": "Message",
    "contact-form-success": "Message sent successfully!",
    "pay-page-subtitle": "Payment methods",
    "transport-page-subtitle": "Shipping methods",
    "filterbar-title": "Filter by:",
    "filterbar-sort": "Sort by:",
    "filterbar-sort-recomandation": "Recommendation",
    "filterbar-sort-ascending": "Ascending Price",
    "filterbar-sort-descending": "Descending Price",
    "shop-item-number": "products",
    "filterbar-color": "Color",
    "filterbar-material": "Material type",
    "filterbar-rating": "Rating",
    "no-data": "No results found",
    "register-phone": "Phone number",
    "passwords-not-match": "Passwords do not match",
    "passwords-rule":
      "Password must have at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character",
    "register-success": "User registered successfully !",
    "login-error":
      "The entered data is incorrect or the account does not exist",
    "register-error": "An error occurred while registering",
    "filterbar-custom": "Custom",
    "filterbar-price": "Price Range",
    "home-read-more": "Read More",
    "home-about-us": "About Us",
    "home-about-printing": "3D Printing and Filament",
    "custom-project-title": "Custom Projects",
    "header-menu-colors": "Colors",
    "add-to-cart": "Add to cart",
    "custom-product-cips": "Customizable",
    "rating-number": "Ratings",
    "error-loading": "Oops, an error occurred...",
    "reviews-msg": "Message",
    "review-title-form": "Share your experience",
    "revie-open-form": "Write a review",
    "review-close-form": "Close",
    "review-success": "Review sent successfully",
    "reviews-title": "Reviews",
    "reviews-success": "Review sent successfully",
    "reviews-error": "An error occurred while sending the review",
    "checkout-title": "YOUR CART",
    "checkout-empty": "Your cart is empty",
    "checkout-summary-order": "Order details",
    "checkout-summary-place-order": "Place order",
    "checkout-summary-total": "Total:",
    "checkout-summary-subtotal": "Subtotal:",
    "checkout-summary-items": "products",
    "checkout-summary-shipping": "Shipping method",
    "checkout-summary-payment": "Payment method",
    "checkout-summary-shipping-1": "Personal pickup, Sector 6, București",
      "checkout-summary-shipping-3": "Home delivery Sector 6",
    "checkout-summary-shipping-2": "Home delivery (+ 20 lei)",
    "checkout-summary-payment-1": "Cash on delivery (+ 10 lei)",
    "checkout-summary-payment-2": "Online payment with card",
    "checkout-summary-payment-3": "Payment by bank transfer",
    "checkout-summary-billing": "Shipping address",
    "checkout-summary-title": "Order Summary",
    "checkout-summary-items-number": "Number of products:",
    "checkout-summary-terms": "I agree with the terms and conditions",
    "checkout-summary-terms-error": "You must accept the terms and conditions",
    "checkout-summary-shipping-error": "Choose a shipping method",
    "checkout-summary-payment-error": "Choose a payment method",
    "checkout-summary-address-error": "Shipping address is required",
    "checkout-summary-county": "County",
    "checkout-summary-city": "City",
    "checkout-summary-address": "Address",
    "checkout-summary-save-address": "Save this address as favorite",
    "add-product-success": "Product added to cart",
    "account-title": "My Account",
    "account-address": "My Saved Addresses",
    "account-orders": "My Orders",
    "account-no-data": "No data available",
    "account-no-orders": "No orders available",
    "account-no-address":
      "No address available. Please add and save an address at checkout.",
    "account-address-title": "Saved shipping and billing address",
    "account-details-title": "Account details",
    "account-orders-number": "Order number:",
    "account-orders-status": "Order status:",
    "account-orders-date": "Order date:",
    "checkout-summary-new-address": "Add a new address",
    "checkout-summary-login": "Log in to place the order.",
    "account-orders-payment": "Payment and shipping method:",
    "checkout-summary-order-error":
      "An error occurred while placing the order!",
    "chechout-success": "Order placed successfully!",
    "chechout-unpaied": "Order placed successfully, but the payment faild!",
    "chechout-success-subtitle":
      "Thank you for your order! We will contact you as soon as possible.",
    "reset-password-title": "Reset Password",
    "reset-password-button": "Reset",
    "reset-password-success": "Password reset successfully",
    "reset-password-error": "An error occurred while resetting the password",
    "reset-password-login-msg": "You can log in with your new password",
    "reset-pass-log-modal": "Forgot your password? Click here to reset it.",
    "login-reset-email":
      "Please enter your email address to receive a reset password link.",
    "login-reset-success":
      "A link to reset your password has been sent to your email address.",
    "reset-error":
      "An error occurred while sending the password reset email. Check the email address.",
  },
  ro: {
    "footer-social-media-section-title": "SOCIAL",
    "footer-social-media-section-description": "Urmărește-ne pe social media",
    "footer-support-section-title": "SUPORT CLIENȚI",
    "footer-utils-section-title": "INFORMAȚII UTILE",
    "footer-retur-section": "Politica de Retur",
    "footer-pay-section": "Transport și Plată",
    "footer-terms-section": "Termeni și Condiții",
    "header-menu-home": "Home",
    "header-menu-shop": "Shop",
    "header-menu-projects": "Proiecte",
    "header-menu-support": "Suport Clienți",
    "login-register-message":
      "Nu ai încă cont? Înregistrează-te și hai să începem!",
    "register-login-message": "Ai deja cont?",
    "login-button": "Login",
    "register-button": "Register",
    "logout-button": "Logout",
    "go-register": "Către Înregistrare",
    "go-login": "Către Login",
    "login-title": "Sign In",
    "register-title": "Sign Up",
    "register-first-name": "Prenume",
    "register-last-name": "Nume",
    "error-404-page-message":
      "Pare că am rămas fără filament... Pană refacem stocul te poti uita printre produsele noastre!",
    "contact-form-save": "Trimite",
    "contact-form-email": "Email",
    "contact-form-subject": "Subiect",
    "contact-form-msg": "Mesaj",
    "contact-form-success": "Mesajul a fost trimis cu succes!",
    "pay-page-subtitle": "Modalități de plată",
    "transport-page-subtitle": "Modalități de transport",
    "filterbar-title": "Filtrează după:",
    "filterbar-sort": "Sortează după:",
    "filterbar-sort-recomandation": "Recomandare",
    "filterbar-sort-ascending": "Pret Crescător",
    "filterbar-sort-descending": "Pret Descrescător",
    "shop-item-number": "produse",
    "filterbar-color": "Culoare",
    "filterbar-material": "Tip material",
    "filterbar-rating": "Rating",
    "no-data": "Nu există rezultate",
    "register-phone": "Număr de telefon",
    "passwords-not-match": "Parolele nu se potrivesc",
    "passwords-rule":
      "Parola trebuie să aibă cel puțin 8 caractere, o literă mare, o literă mică, un număr și un caracter special",
    "register-success": "Utilizator înregistrat cu succes !",
    "login-error": "Datele introduse sunt incorecte sau contul nu există",
    "register-error": "A apărut o eroare la înregistrare",
    "filterbar-custom": "Personalizabil",
    "filterbar-price": "Interval Preț",
    "home-read-more": "Descoperă",
    "home-about-us": "Despre noi",
    "home-about-printing": "Printarea 3D și Filamentul",
    "custom-project-title": "Proiecte personalizate",
    "header-menu-colors": "Culori",
    "add-to-cart": "Adaugă în coș",
    "custom-product-cips": "Personalizabil",
    "rating-number": "Recenzii",
    "error-loading": "Ups, a apărut o eroare...",
    "reviews-msg": "Mesaj",
    "review-title-form": "Împărtășește-ți experiența",
    "revie-open-form": "Scrie o recenzie",
    "review-close-form": "Închide",
    "review-success": "Recenzia a fost trimisă cu succes",
    "reviews-title": "Recenzii",
    "reviews-success": "Recenzia a fost trimisă cu succes",
    "reviews-error": "A apărut o eroare la trimiterea recenziei",
    "checkout-title": "COȘUL TĂU",
    "checkout-empty": "Coșul tău este gol",
    "checkout-summary-order": "Detalii comandă",
    "checkout-summary-place-order": "Plaseaza comanda",
    "checkout-summary-total": "Total:",
    "checkout-summary-subtotal": "Subtotal:",
    "checkout-summary-items": "produse",
    "checkout-summary-billing": "Adresa de livrare",
    "checkout-summary-shipping": "Metoda de livrare",
    "checkout-summary-payment": "Metoda de plată",
    "checkout-summary-shipping-1": "Ridicare personală Sector 6, București",
      "checkout-summary-shipping-3": "Livrare Sector 6",
    "checkout-summary-shipping-2": "Livrare la domiciliu (+ 20 lei)",
    "checkout-summary-payment-1": "Ramburs (+ 10 lei)",
    "checkout-summary-payment-2": "Plata online cu cardul",
    "checkout-summary-payment-3": "Plata prin transfer bancar",
    "checkout-summary-title": "Sumar Comandă",
    "checkout-summary-items-number": "Număr produse:",
    "checkout-summary-terms": "Sunt de acord cu termenii și condițiile",
    "checkout-summary-terms-error": "Trebuie să accepti termenii și condițiile",
    "checkout-summary-shipping-error": "Alegeți o metodă de livrare",
    "checkout-summary-payment-error": "Alegeți o metodă de plată",
    "checkout-summary-address-error": "Adresa de livrare este obligatorie",
    "checkout-summary-county": "Județ",
    "checkout-summary-city": "Oraș",
    "checkout-summary-address": "Adresă",
    "checkout-summary-save-address": "Salvează aceasta adresă ca favorită",
    "add-product-success": "Produs adăugat în coș",
    "account-title": "Contul meu",
    "account-address": "Adresa mea salvată",
    "account-orders": "Comenzile mele",
    "account-no-data": "Nu există date disponibile",
    "account-no-orders": "Nu există comenzi disponibile",
    "account-no-address":
      "Nu există adrese disponibile. Te rugăm să adaugi și să salvezi adresa la plasarea comenzii.",
    "account-address-title": "Adresa de livrare și facturare salvată",
    "account-details-title": "Detaliile contului",
    "account-orders-number": "Numărul comenzii:",
    "account-orders-payment": "Metoda plată și livrare:",
    "account-orders-status": "Status comanda:",
    "account-orders-date": "Data comenzii:",
    "checkout-summary-new-address": "Folosește o altă adresă",
    "checkout-summary-login": "Loghează-te pentru a putea plasa comanda.",
    "checkout-summary-order-error": "A apărut o eroare la plasarea comenzii!",
    "chechout-success": "Comanda a fost plasată cu succes! ",
    "chechout-unpaied": "Comanda a fost plasată cu succes, dar plata a eșuat! ",
    "chechout-success-subtitle":
      "Îți mulțumim pentru comanda ta! Te vom contacta în cel mai scurt timp.",
    "login-client-msg":
      "Dacă vrei să începi cumpăraturile, acesta nu este locul potrivit. Te rugăm să te conectezi utilizând fereastra pentru clienți.",

    "reset-password-title": "Resetează parola",
    "reset-password-button": "Resetează",
    "reset-password-success": "Parola a fost resetată cu succes",
    "reset-password-error": "A apărut o eroare la resetarea parolei",
    "reset-password-login-msg": "Te poți conecta cu noua ta parolă",
    "reset-pass-log-modal": "Ai uitat parola? Click aici pentru a o reseta.",
    "login-reset-email":
      "Te rugăm să introduci adresa ta de email pentru a primi un link de resetare a parolei.",
    "login-reset-success":
      "Un link pentru resetarea parolei a fost trimis la adresa ta de email.",
    "reset-error":
      "A apărut o eroare la trimiterea formularului de resetare a parolei. Verificati corectitudinea emailului.",
  },
};
